<template>
  <div>
    <div class="row">
      <h3 class="col-xs-6">
        Lokale noter
      </h3>
      <div class="row end-xs col-xs-6">
        <BaseButton
          @click.prevent="onAddNewLocalNote"
          label="Opret ny lokal note"
        />
      </div>
    </div>

    <div
      class="border-bottom"
      v-if="notes.length"
    />

    <div class="row">
      <LocalNote
        :note="note"
        v-for="(note, noteIndex) in notes"
        :key="noteIndex"
        :disabled="note.inherited"
        class="col-xs-6"
        @remove="$emit('remove', noteIndex)"
      />
    </div>
  </div>
</template>

<script>
import LocalNote from './LocalNote.vue';
import BaseButton from './BaseButton.vue';

export default {
    name: 'LocalNotes',
    components: { BaseButton, LocalNote },
    props: {
        notes: { type: Array, required: true },
    },
    methods: {
        onAddNewLocalNote() {
            this.$emit('add', {
                iconID: -1,
                headline: '',
                description: '',
                links: [],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.border-bottom {
    border-bottom: 1px solid $gray2;
    padding-bottom: 10px;
    margin-bottom: 20px;
}
</style>
